import React, { useState } from 'react';
import { waLink } from '../lib/whatsapp';

const categories = [
  { id: 'credito', label: 'Crédito y financiamiento', icon: 'account_balance' },
  { id: 'entrega', label: 'Entrega y diseño', icon: 'engineering' },
  { id: 'escrituracion', label: 'Escrituración', icon: 'description' },
  { id: 'mantenimiento', label: 'Mantenimiento', icon: 'home_repair_service' },
];

const faqs = {
  credito: [
    {
      q: '¿Qué tipos de crédito aceptan?',
      a: 'Aceptamos INFONAVIT, FOVISSSTE, créditos bancarios (BBVA, Santander, Banorte, Banamex, Scotiabank, HSBC), cofinanciamiento (INFONAVIT + Banco o INFONAVIT + FOVISSSTE) y pago de contado. Cada caso se asesora de forma personalizada para encontrar la mejor opción.',
    },
    {
      q: '¿El precio es el mismo para todas las casas?',
      a: 'Las viviendas inician en $2,475,000. El precio final varía según el modelo, las adecuaciones adicionales que se elijan (por ejemplo, reja de protección, canceles de baño, pergolado o cambio de cubiertas de cocina) y el terreno: el lote tipo es de 127.5 m², pero hay lotes con terreno adicional. Un asesor te confirma el precio exacto de cada caso.',
    },
    {
      q: '¿Cuál es el enganche mínimo?',
      a: 'El enganche es a partir del 10% del valor de la vivienda. El porcentaje final depende de la forma de pago y de cada caso; un asesor te lo confirma.',
    },
    {
      q: '¿Pueden ayudarme a juntar dos créditos?',
      a: 'Sí, manejamos cofinanciamiento INFONAVIT + Banco e INFONAVIT + FOVISSSTE. Nuestro equipo te asesora sin costo para que aproveches al máximo tu capacidad de crédito combinada. También aceptamos coacreditados: por ejemplo, cónyuges que juntan sus créditos.',
    },
    {
      q: '¿Cuánto tarda la aprobación del crédito?',
      a: 'En todos los casos (INFONAVIT, FOVISSSTE o bancario), la aprobación toma entre 5 y 15 días hábiles. Te acompañamos durante todo el proceso para acelerar la aprobación con tu banco o instituto.',
    },
  ],
  entrega: [
    {
      q: '¿Cuándo entregan las casas?',
      a: 'En esta etapa estamos edificando prácticamente sobre pedido, para que cada vivienda pueda recibir adecuaciones personalizadas. El proceso de construcción suele tomar entre 4 y 6 meses, dependiendo de factores como la forma de pago, la carga de obra del momento y el calendario que acuerdes con el equipo. Te acompañamos con avance mensual y visitas guiadas a obra para que veas el progreso real.',
    },
    {
      q: '¿Qué incluye la entrega de la casa?',
      a: 'Las casas se entregan totalmente terminadas y listas para habitar: cocina integral completa (mobiliario), clósets en todas las recámaras, pisos cerámicos y de madera, pintura interior y exterior, sanitarios, luminarias, calentador de agua y tableros eléctricos. Importante: los electrodomésticos (estufa, horno, campana, parrilla, refrigerador) NO están incluidos — únicamente entregamos el mobiliario de cocina.',
    },
    {
      q: '¿Puedo modificar el plano o personalizar acabados?',
      a: 'Sí, siempre y cuando las adecuaciones se definan ANTES de la firma del contrato promesa de compra-venta. Como construimos sobre pedido, podemos integrar: cuarta recámara o estudio, paneles solares, calentador eléctrico, preparaciones para aire acondicionado, preparaciones para cargador de vehículo eléctrico, y roof garden con pérgola y asador. Toda la coordinación se hace con nuestro equipo de ventas y técnico. Las pinturas exteriores están homologadas en todo el fraccionamiento; los acabados interiores sí pueden personalizarse antes de la firma del contrato.',
    },
    {
      q: '¿Qué garantías incluye la casa?',
      a: '5 años en estructura, 3 años en impermeabilización, y 1 año en instalaciones hidrosanitarias, eléctricas y acabados (pisos, pintura, carpintería, etc.). Atención de servicio post-venta sin costo durante el periodo de garantía.',
    },
  ],
  escrituracion: [
    {
      q: '¿Cuándo se firma la escritura?',
      a: 'La escritura se firma una vez que el crédito está aprobado y previo a la entrega de la vivienda. Como construimos sobre pedido, el proceso constructivo toma entre 4 y 6 meses, y la escrituración se realiza antes de hacerte entrega de tu casa. La firma se hace ante notario público en la Ciudad de Pachuca.',
    },
    {
      q: '¿Qué gastos cubre el comprador?',
      a: 'Aproximadamente un 5% sobre el valor de la propiedad, que incluye gastos notariales, avalúo, ISR (cuando aplica), comisión por apertura del banco y CLG (Certificado de Libertad de Gravamen). Tenemos paquetes de apoyo según el banco con el que califiques.',
    },
    {
      q: '¿Puedo escriturar antes de terminar de pagar?',
      a: 'Sí. Con crédito hipotecario escrituras al inicio quedando la casa en garantía. Si pagas de contado, la escritura se realiza al liquidar el saldo.',
    },
  ],
  mantenimiento: [
    {
      q: '¿Cuál es la cuota de mantenimiento?',
      a: 'La cuota mensual es de $700 MXN e incluye: vigilancia 24/7, mantenimiento de áreas verdes, alumbrado público, recolección de basura y mantenimiento de amenidades comunes.',
    },
    {
      q: '¿Hay reglamento interno?',
      a: 'Sí, contamos con un reglamento interno de convivencia. Se entrega al firmar la escritura y forma parte integral de la misma. Cubre uso de áreas comunes, mascotas, ruidos, modificaciones a fachada y horarios.',
    },
    {
      q: '¿Puedo rentar mi casa?',
      a: 'Sí, sin restricción. Muchos propietarios rentan a corto y largo plazo. La ubicación a 10 min del centro de Pachuca y la seguridad del residencial las hacen muy atractivas para inquilinos.',
    },
  ],
};

function FaqItem({ q, a, idx, openIdx, setOpenIdx }) {
  const isOpen = openIdx === idx;
  return (
    <div className={`faq-item${isOpen ? ' open' : ''}`} data-testid={`faq-item-${idx}`}>
      <button
        className="faq-question"
        onClick={() => setOpenIdx(isOpen ? -1 : idx)}
        aria-expanded={isOpen}
      >
        <span className="faq-question-text">{q}</span>
        <span className={`icon-font faq-toggle${isOpen ? ' rotated' : ''}`}>add</span>
      </button>
      <div className="faq-answer-wrap" style={{ maxHeight: isOpen ? '400px' : '0' }}>
        <div className="faq-answer">{a}</div>
      </div>
    </div>
  );
}

export default function FAQSection() {
  const [activeCat, setActiveCat] = useState('credito');
  const [openIdx, setOpenIdx] = useState(0);

  const switchCat = (id) => {
    setActiveCat(id);
    setOpenIdx(0);
  };

  return (
    <section id="faq" className="faq-section" data-testid="faq-section">
      <div className="page-padding">
        <div className="container-large">
          <div className="faq-grid">
            <div className="faq-side">
              <div className="text-label" style={{ color: 'var(--color-two)' }}>preguntas frecuentes</div>
              <h2 className="sm-h2 font-color-1" data-reveal>
                Resolvemos tus <span className="serif-accent">dudas.</span>
              </h2>
              <p className="text-size-medium" style={{ color: 'var(--body-font)', marginTop: '0.5rem' }}>
                Las preguntas más comunes de quienes están por convertirse en parte de Santa Mónica Residencial.
              </p>
              <div className="faq-cats" data-testid="faq-categories">
                {categories.map((c) => (
                  <button
                    key={c.id}
                    className={`faq-cat${activeCat === c.id ? ' active' : ''}`}
                    onClick={() => switchCat(c.id)}
                    data-testid={`faq-cat-${c.id}`}
                  >
                    <span className="icon-font">{c.icon}</span>
                    <span>{c.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="faq-list" data-testid="faq-list">
              {faqs[activeCat].map((f, i) => (
                <FaqItem key={`${activeCat}-${i}`} idx={i} openIdx={openIdx} setOpenIdx={setOpenIdx} {...f} />
              ))}
              <div className="faq-cta">
                <span>¿Tu duda no está aquí?</span>
                <a
                  href={waLink('Hola, tengo una pregunta sobre Santa Mónica Residencial')}
                  target="_blank" rel="noopener noreferrer"
                  className="faq-cta-link"
                  data-testid="faq-whatsapp"
                >
                  <img loading="lazy" src="/images/whatsapp.svg" alt="WA" />
                  Pregúntanos por WhatsApp
                  <span className="icon-font">arrow_forward</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
